import { UserCommitmentRankingEntryService } from './UserCommitmentRankingEntryService';

export default {
	'services.ranking.userCommitmentRankingEntryService': {
		class: UserCommitmentRankingEntryService,
	},
};
